import { sharedExtensionCards } from '../gameData/extensions.shared';
import { ExtensionContext } from '../types/ExtensionCard';

export const getExtensionAdditionalFood = (
  context: ExtensionContext,
): number => {
  const extensionData = sharedExtensionCards[context.extension.type];
  if (extensionData.customAdditionalFood) {
    return extensionData.customAdditionalFood(context);
  }
  return extensionData.additionalFood;
};
